/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function() {
				// JavaScript to be fired on all pages

				//fixed deep-nav on scroll and control scroll up for sho top menu

					var $window = $(window);
					var previousScrollTop = 0;
					var currentScrollTop = 0;

					var $menu = $("#topbar");
					var $spacerMenu = $("#spacer-topbar");

					var alturaMenu = $menu.outerHeight();
					$menu.css('top', '-' + alturaMenu + 'px');
/**
*el código que comentamos es para eliminar la funcionalidad de fijar el menu secondario al top cuando se supera su scroll
*existe otro bloque relacionado más abajo en el evento scroll
					var $deep = $('#deep-navigation');
					var $spacerDeep = $('#spacerDeep');

					var deepOffsetTop = 0;
					var heightDeep = 0;

					if($deep.length){
						deepOffsetTop = $deep.offset().top;
						heightDeep = $deep.outerHeight();
					}
*/

					$window.scroll(function () {

						currentScrollTop = $(this).scrollTop();

						if (currentScrollTop > previousScrollTop){
							 $menu.css('top', '-' + alturaMenu + 'px');
							 //$menu.removeClass("hiddenable");

						} else {
							$spacerMenu.css('height', alturaMenu + 'px');
							$menu.addClass("hiddenable");
							$menu.addClass("rojo");
							$menu.css('top', '0');
						}
						if ( $(this).scrollTop() <= 0){
							 //menu.css('top', '-' + alturaMenu + 'px');
							 $menu.removeClass("rojo");
							 //$menu.removeClass("hiddenable");
							 //$spacerMenu.css('height', 0);
							$menu.one('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd',
							function() {
								 $menu.removeClass("hiddenable");
								 $spacerMenu.css('height', 0);
							});
						}


						previousScrollTop = currentScrollTop;

/**
el código que comentamos es para eliminar la funcionalidad de fijar el menu secondario al top cuando se supera su scroll

						if ( currentScrollTop > deepOffsetTop) {
							$deep.addClass("fixed-top-nav");
							$spacerDeep.css('height', heightDeep + 'px');

						} else {
							$deep.removeClass("fixed-top-nav");
							$spacerDeep.css('height', 0);
						}

*/



					});

					//manejamos el click de los enlaces con hash hacia anchors para animar el salto al anchor
					//$('a[href*="#"]').bind('click',function (e) {

					$('a.motion-link').bind('click',function (e) {
							e.preventDefault();
							var target = this.hash;
							$target = $(target);
							var tope = $target.offset().top;

							$('html, body').stop().animate({
									'scrollTop': tope
							}, 1000, 'swing', function () {
									//window.location.hash = target;
								if(history.pushState) {
									history.pushState(null, null, target);
								}
								else {
									location.hash = target;
								}
							});
					});

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
		// Home page
		'home': {
			init: function() {
				// JavaScript to be fired on the home page
			},
			finalize: function() {
				// JavaScript to be fired on the home page, after the init JS
			}
		},
		// About us page, note the change from about-us to about_us.
		'mediateca': {
			init: function() {
				console.log('Description');
			}
		},
		// About us page, note the change from about-us to about_us.
		'about_us': {
			init: function() {
				// JavaScript to be fired on the about us page
			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
